import { AlertTriangle, X } from 'lucide-react';
import { useState } from 'react';

import { ptBR } from '@/i18n/pt-BR';
import type { ReferenceSetInstabilityData } from '@/lib/case_workspace';
import { cn } from '@/lib/utils';

export interface ReferenceSetInstabilityBannerProps {
  instability: ReferenceSetInstabilityData | null;
  className?: string;
}

/**
 * Banner de "variação entre as amostras de referência" (E16.F2 / ADR-0016). // ux-neutrality:allow doc-comment
 *
 * Renderiza quando as amostras de referência apontam direções opostas (o // ux-neutrality:allow doc-comment
 * veredito vira inconclusivo). Espelha o ProportionWarningBanner (E15.F4): // ux-neutrality:allow doc-comment
 * dismissível (estado local), render zero quando não há instabilidade ou já // ux-neutrality:allow doc-comment
 * dispensado, e o chamador passa `key={caseId}` para resetar o dismiss ao // ux-neutrality:allow doc-comment
 * trocar de caso (mesma lição da F-E15.F4-01). // ux-neutrality:allow doc-comment
 */
export function ReferenceSetInstabilityBanner({
  instability,
  className,
}: ReferenceSetInstabilityBannerProps): JSX.Element | null {
  const [dismissed, setDismissed] = useState(false);
  if (!instability?.unstable || dismissed) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="instability-warning-banner"
      className={cn(
        'flex items-start gap-3 border border-warning/40 bg-warning-50 px-sc-4 py-sc-3 text-body-sm text-warning-700',
        className,
      )}
    >
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" aria-hidden />
      <div className="flex-1">
        <p className="font-medium">{ptBR.workspaceCaso.instabilityWarningTitle}</p>
        <p className="mt-1">{ptBR.workspaceCaso.instabilityWarningMessage}</p>
      </div>
      <button
        type="button"
        onClick={() => setDismissed(true)}
        data-testid="instability-warning-dismiss"
        aria-label={ptBR.workspaceCaso.instabilityWarningDismiss}
        className="shrink-0 p-1 text-warning-700 transition-colors duration-fast ease-sc hover:bg-warning/20"
      >
        <X className="h-4 w-4" aria-hidden />
      </button>
    </div>
  );
}
